var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import { CardActionArea } from '@material-ui/core';
import { mdiLaunch, mdiLink } from '@mdi/js';
import Icon from '@mdi/react';
import styled from 'styled-components';
import { IconSize } from '../../../..';
import { AdeptCard, AdeptCardContent } from '../../../Structure';
import { LaunchIcon } from '../VirtualLabViewer/lab.styles';
const Iframe = styled.iframe `
    max-height: 10rem;
`;
const OGImage = styled.img `
    max-height: 6rem;
    max-width: 10rem;
`;
export const LinkMetadata = (_a) => {
    var _b, _c, _d;
    var { link, onClick } = _a, others = __rest(_a, ["link", "onClick"]);
    const { CardImageAreaComponent } = useMemo(() => {
        var _a, _b;
        if ((_a = link === null || link === void 0 ? void 0 : link.details) === null || _a === void 0 ? void 0 : _a.ogVideo) {
            return {
                CardImageAreaComponent: React.createElement(Iframe, { src: link.details.ogVideo.url }),
                ogSpacing: true
            };
        }
        if ((_b = link === null || link === void 0 ? void 0 : link.details) === null || _b === void 0 ? void 0 : _b.ogImage) {
            return { CardImageAreaComponent: React.createElement(OGImage, { src: link.details.ogImage.url }), ogSpacing: true };
        }
        return { CardImageAreaComponent: React.createElement(Icon, { path: mdiLink, size: IconSize.Medium }), ogSpacing: false };
    }, [link]);
    return (React.createElement(AdeptCard, Object.assign({ style: { minWidth: '100%' } }, others),
        React.createElement(CardActionArea, { onClick: onClick ? onClick : () => { }, disableRipple: true },
            React.createElement(AdeptCardContent, { style: { display: 'table', height: 'inherit' }, title: ((_b = link === null || link === void 0 ? void 0 : link.details) === null || _b === void 0 ? void 0 : _b.ogTitle) ? link.details.ogTitle : link.text, contentImageComponent: CardImageAreaComponent, secondaryInfo: (link === null || link === void 0 ? void 0 : link.details) ? [(_d = (_c = link === null || link === void 0 ? void 0 : link.details) === null || _c === void 0 ? void 0 : _c.ogDescription) !== null && _d !== void 0 ? _d : '']
                    : [
                        'Link details are being fetched in the background, please refresh or toggle edit modes to see the latest details.'
                    ], lowerRightComponent: React.createElement(LaunchIcon, { "$disabled": !!onClick, path: mdiLaunch, size: IconSize.Medium }) }))));
};
//# sourceMappingURL=Metadata.js.map